import Contaier from "../../components/layout/Container/Container";
import CompleteImg from "../../assets/eservice-img-suss.png";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";

const HarvestDetailsApplicationComplete = () => {
  const location = useLocation();
  const refNumber = location.state;
  let bannerName = "Harvest Details Registration";

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/harvest-details`;
    navigate(path);
  };

  return (
    <>
      <Header />
      <Contaier>
        <div className="inner-content pt-5 pb-5">
          <div className="container">
            <div className="landing-page tag-list mt-5 mb-5">
              <figure>
                <img src={CompleteImg} alt="" className="img-fluid" />
              </figure>
              {refNumber.editMode !== "" && (
                <p>
                  Harvest details have been updated. Our officers will review
                  the details you have provided before your request is approved.
                </p>
              )}
              {refNumber.editMode === "" && refNumber.type === "" && (
                <p>
                  Your submission has been successful with reference number{" "}
                  {refNumber.refNumber}. Our officers will review the details
                  you have provided before your request is approved.
                </p>
              )}

              {refNumber.editMode === "" && refNumber.type !== "extend" && (
                <p>
                  Your submission has been successful with reference number{" "}
                  {refNumber.refNumber}.
                </p>
              )}
              <button
                type="button"
                className="btn btn-success mt-4"
                onClick={routeChange}
              >
                Back to Harvest Details
              </button>
            </div>
          </div>
        </div>
      </Contaier>
    </>
  );
};

export default HarvestDetailsApplicationComplete;
